import React from "react";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import { buttonName, monthlyCommison } from "../../locales/en";
import CommonModal from "./CommonModal";
import SalesInvoiceReportModalTable from "../table/all-tables/reportable/monthlysalescommision/invoice/SalesInvoiceReportModalTable";
const MonthlySalesInvoiceDetailsModal = ({
  isOpen,
  toggle,
  invoiceIdsListRef
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={monthlyCommison?.modal?.title}
      modalClassName="modal-fullscreen w-100 h-auto"
      bodyClassName={Modalstyle.refMonthlySingleContent}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: () => toggle(false)
        }
      ]}
    >
      <SalesInvoiceReportModalTable invoiceIdsListRef={invoiceIdsListRef} />
    </CommonModal>
  );
};

MonthlySalesInvoiceDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  selectedInvoiceIds: PropTypes.any,
  invoiceIdsListRef: PropTypes.object
};
export default MonthlySalesInvoiceDetailsModal;
